unit UTaetModel;

interface

uses
  Js;

type
  TTaetModel = class
  private
    FBezeichnung: string;
    FId: Integer;
    FAbrechnung: Boolean;
    FAnzNr: Integer;
    FFPapId: Integer;
    procedure SetValues(obj: TJsObject); overload;
    procedure SetBezeichnung(const Value: string);
    procedure SetId(const Value: Integer);
    procedure SetAbrechnung(const Value: Boolean);
    procedure SetAnzNr(const Value: Integer);
    procedure SetFPapId(const Value: Integer);
  public
    constructor Create; overload;
    constructor Create(json: string); overload;
    function ToJson: string;
    function ToString: string; override;
    procedure ClearValues;
    procedure SetValues(json: string); overload;
    property Id: Integer read FId write SetId;
    property Bezeichnung: string read FBezeichnung write SetBezeichnung;
    property FPapId: Integer read FFPapId write SetFPapId;
    property AnzNr: Integer read FAnzNr write SetAnzNr;
    property Abrechnung: Boolean read FAbrechnung write SetAbrechnung;
  end;

implementation

uses
  System.SysUtils, WebLib.json, UEssentialHelper;

{ TTaetModel }

procedure TTaetModel.ClearValues;
begin
  Self.Id := 0;
  Self.Bezeichnung := '';
  Self.FPapId := 0;
  Self.AnzNr := 0;
  Self.Abrechnung := false;
end;

constructor TTaetModel.Create;
begin
  Self.ClearValues;
end;

constructor TTaetModel.Create(json: string);
begin
  Self.SetValues(json);
end;

procedure TTaetModel.SetAbrechnung(const Value: Boolean);
begin
  FAbrechnung := Value;
end;

procedure TTaetModel.SetAnzNr(const Value: Integer);
begin
  FAnzNr := Value;
end;

procedure TTaetModel.SetBezeichnung(const Value: string);
begin
  FBezeichnung := Value;
end;

procedure TTaetModel.SetFPapId(const Value: Integer);
begin
  FFPapId := Value;
end;

procedure TTaetModel.SetId(const Value: Integer);
begin
  FId := Value;
end;

procedure TTaetModel.SetValues(obj: TJsObject);
begin
  Self.ClearValues;
  if obj['Id'] <> nil then
    Self.Id := StrToInt(string(obj['Id']));
  if obj['Bezeichnung'] <> nil then
    Self.Bezeichnung := string(obj['Bezeichnung']);
  if obj['FPapId'] <> nil then
    Self.FPapId := StrToInt(string(obj['FPapId']));
  if obj['AnzNr'] <> nil then
    Self.AnzNr := StrToInt(string(obj['AnzNr']));
  if obj['Abrechnung'] <> nil then
    Self.Abrechnung := StrToBoolean(string(obj['Abrechnung']));
end;

function TTaetModel.ToJson: string;
var
  obj: TJsonObject;
begin
  obj := TJsonObject.Create;
  obj.AddPair('Id', IntToStr(Self.Id));
  obj.AddPair('Bezeichnung', Self.Bezeichnung);
  obj.AddPair('FPapId', IntToStr(Self.FPapId));
  obj.AddPair('AnzNr', IntToStr(Self.AnzNr));
  obj.AddPair('Abrechnung', BooleanToStr(Self.Abrechnung));
  Result := obj.ToString;
end;

function TTaetModel.ToString: string;
begin
  Result := Self.Bezeichnung;
end;

procedure TTaetModel.SetValues(json: string);
var
  obj: TJsObject;
begin
  obj := TJsJson.parseObject(json);
  Self.SetValues(obj);
end;

end.
